import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./login.css";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    if (location.state?.message) {
      setSuccess(location.state.message);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    setError("");
    setSuccess("");
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email.trim()) {
      setError("Email is required");
      return false;
    }

    if (!emailRegex.test(form.email)) {
      setError("Enter a valid email");
      return false;
    }

    if (!form.password.trim()) {
      setError("Password is required");
      return false;
    }

    if (form.password.length < 6) {
      setError("Password must be at least 6 characters");
      return false;
    }

    return true;
  };

  const mergeGuestCartWithUserCart = (user) => {
    const userEmail = user?.email || form.email;

    if (!userEmail) return;

    const guestCart = JSON.parse(localStorage.getItem("cart_guest")) || [];
    const oldCart = JSON.parse(localStorage.getItem("cart")) || [];

    const userCartKey = `cart_${userEmail}`;
    const userCart = JSON.parse(localStorage.getItem(userCartKey)) || [];

    const mergedCart = [...userCart];

    [...guestCart, ...oldCart].forEach((guestItem) => {
      const existingIndex = mergedCart.findIndex(
        (item) =>
          String(item.id || item.name) === String(guestItem.id || guestItem.name) &&
          String(item.variant_id || item.selected_price || item.price) ===
            String(
              guestItem.variant_id ||
                guestItem.selected_price ||
                guestItem.price
            )
      );

      if (existingIndex !== -1) {
        mergedCart[existingIndex].quantity =
          Number(mergedCart[existingIndex].quantity || 1) +
          Number(guestItem.quantity || 1);
      } else {
        mergedCart.push(guestItem);
      }
    });

    localStorage.setItem(userCartKey, JSON.stringify(mergedCart));
    localStorage.removeItem("cart_guest");
    localStorage.removeItem("cart");
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);
      setError("");

      const res = await fetch("https://dashboard.jyotirvani.com/user-auth", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.status === false) {
        setError(data?.message || "Login failed");
        return;
      }

      const userData = data.user || data.customer || data.data || data;

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("user", JSON.stringify(userData));

      if (userData?.id) {
        localStorage.setItem("user_id", userData.id);
      }

      mergeGuestCartWithUserCart(userData);

      window.dispatchEvent(new Event("loginUpdated"));
      window.dispatchEvent(new Event("cartUpdated"));

      navigate(from, { replace: true });
    } catch (err) {
      console.error("LOGIN ERROR:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-overlay">
        <div className="login-card">
          <div className="login-left">
            <h1>Welcome Back</h1>
            <p>
              Login to continue your astrology journey, consultations, puja
              booking, gemstone guidance, and premium services.
            </p>
          </div>

          <div className="login-right">
            <h2>Login</h2>
            <p className="login-subtitle">Sign in to continue</p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-field">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="login-field">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>

              <div className="forgot-password">
                <button
                  type="button"
                  className="forgot-password-btn"
                  onClick={handleForgotPassword}
                >
                  Forgot Password?
                </button>
              </div>

              {error && <p className="login-error">{error}</p>}
              {success && <p className="login-success">{success}</p>}

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>

            <div className="register-link">
              <p>
                Don't have an account?{" "}
                <a
                  href="/register"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/register");
                  }}
                >
                  Register here
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;